export default __webpack_public_path__ + "static/media/property_1007.b6960351.png";